import React from "react";
import PropTypes from "prop-types";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from '../../utils/lib/utils';

const Progress = React.forwardRef(function Progress(
  { className, value = 0, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-slate-100",
        className
      )}
      {...props}
    >
      <div
        className="h-full w-full flex-1 bg-slate-900 transition-all"
        style={{
          transform: `translateX(-${100 - (value || 0)}%)`,
        }}
      />
    </div>
  );
});

Progress.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number,
};

Progress.displayName = "Progress";

export default Progress;
